import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { switchMap, tap } from "rxjs";
import { AppInit } from './app-init.action';
import { CategoryStoreService } from '@franbase/frontend/data-access';
import { AuthStore } from '@franbase/shared/auth/data-access';
import { AngularFireAuth } from '@angular/fire/compat/auth';
@Injectable()
export class ApplicationEffects {

  store = inject(Store);
  actions$ = inject(Actions);
  categoryStoreSV = inject(CategoryStoreService);
  authStore = inject(AuthStore);
  afAuth = inject(AngularFireAuth);

  // initAuth$ = createEffect(
  //   () =>
  //     this.actions$.pipe(
  //       ofType(AppInit),
  //       tap(() => {
  //         this.categoryStoreSV.loadCategory$();
  //       })
  //     ),
  //   {
  //     dispatch: false
  //   }
  // );

  initAuth$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AppInit),
        switchMap(() => {
          this.authStore.init2();
          this.categoryStoreSV.loadCategory$();
          return this.authStore.auth_id$;
        })
      ),
    {
      dispatch: false
    }
  );
}
